import PropTypes from 'prop-types';
import styles from './spinner.module.scss';
import { augmentClassName } from '../../../utils/GlobalCssProxy';
import { connect } from 'react-redux';

const className = augmentClassName(styles);

const Spinner = ({ resultData, planApiLoading, disclosuresLoading, netGrossDisclosuresLoading }) => {
  if (resultData.loading || planApiLoading || disclosuresLoading || netGrossDisclosuresLoading) {
    return (
      <div {...className('spinner-container')}>
        <div {...className('spinner')}/>
      </div>
    );
  }
  return null;
};

Spinner.propTypes = {
  resultData: PropTypes.object,
  planApiLoading: PropTypes.bool,
  documentsLoading: PropTypes.bool,
  disclosuresLoading: PropTypes.bool,
  netGrossDisclosuresLoading: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    resultData: state.resultData,
    planApiLoading: state.filterReducer.planApiLoading,
    disclosuresLoading: state.rowDocsAndDisclosuresReducer.disclosuresLoading,
    netGrossDisclosuresLoading: state.rowDocsAndDisclosuresReducer.netGrossDisclosuresLoading
  };
};

export default connect(mapStateToProps, null)(Spinner);

